import React, { useState } from "react";
import { Container, Alert } from "../../../components";
import { Button } from "@telia/teddy";
import { connect, useDispatch } from "react-redux";
import IncompleteOrderConfirmation from "./IncompleteOrderConfirmation";
import { FORM_ID } from "../../../../../constants";
import { Form, RootState } from "../../../../../models";
import { FormRow, FormRowFormats, Input } from "../../../forms";
import FieldSet from "../../../forms/components/atoms/FieldSet/FieldSet";
import { selectors as LOADING_SELECTORS } from "../../../loading";
import { RapidForm } from "../../../rapidform";
import { VALIDATION_FIELD } from "../../../rapidform/formValidation";
import { submitIncompleteOrderForm } from "../../state/actions/incompleteOrderActions";
import { CHECKOUT_SUBMIT_INCOMPLETE_ORDER_FORM } from "../../state/actionTypes";
import "./incompleteOrder.less";
import { getFormById } from "../../state/selectors/formSelectors";

interface IncompleteOrderProps {
    form: Form;
    isSubmitting: boolean;
}

const IncompleteOrder: React.FC<IncompleteOrderProps> = ({ form, isSubmitting }) => {
    const dispatch = useDispatch();
    const [hasSubmittedForm, setHasSubmittedForm] = useState(false);

    if (hasSubmittedForm) {
        return <IncompleteOrderConfirmation />;
    }
    return (
        <div className="incomplete-order">
            <Container size="small">
                <Alert className="incomplete-order__alert" kind="warning">
                    Vi opplever for tiden tekniske problemer. Fyll ut informasjonen under, og vi gir deg beskjed når du
                    kan fullføre bestillingen.
                </Alert>

                <Container className="beta-checkout__section" size="small">
                    <RapidForm
                        id={FORM_ID.INCOMPLETE_ORDER}
                        action={"#"}
                        errors={form.errors}
                        values={form.values}
                        visible={form.visible}
                        started={form.started}
                        onSubmit={async () => {
                            await dispatch(submitIncompleteOrderForm());
                            setHasSubmittedForm(true);
                        }}
                    >
                        <FieldSet name="details" legend="Kontaktinformasjon" data-di-mask>
                            <Input type="text" name={VALIDATION_FIELD.FIRST_NAME} label="Fornavn" />
                            <Input type="text" name={VALIDATION_FIELD.LAST_NAME} label="Etternavn" />
                            <FormRow format={FormRowFormats.FORTY_SIXTY}>
                                <Input
                                    type="tel"
                                    name={VALIDATION_FIELD.PHONE}
                                    label="Mobilnummer"
                                    disabled={false}
                                    data-di-mask
                                />
                                <Input
                                    type="email"
                                    name={VALIDATION_FIELD.EMAIL}
                                    label="E-post"
                                    disabled={false}
                                    data-di-mask
                                    placeholder="ola@nordmann.no"
                                />
                            </FormRow>
                        </FieldSet>
                    </RapidForm>
                </Container>
                <Button
                    className="incomplete-order__submit-button"
                    variant="primary"
                    type="submit"
                    form={FORM_ID.INCOMPLETE_ORDER}
                    loading={isSubmitting}
                >
                    La oss kontakte deg
                </Button>
            </Container>
        </div>
    );
};

const mapStateToProps = (state: RootState) => ({
    form: getFormById(state, FORM_ID.INCOMPLETE_ORDER),
    isSubmitting: LOADING_SELECTORS.isTypeLoading(state, CHECKOUT_SUBMIT_INCOMPLETE_ORDER_FORM),
});

export default connect(mapStateToProps)(IncompleteOrder);
